import { render, staticRenderFns } from "./button-title.vue?vue&type=template&id=9965d0ce"
import script from "./button-title.vue?vue&type=script&lang=js"
export * from "./button-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports